import { render } from "./MainLayout.vue?vue&type=template&id=0623b992&scoped=true"
import script from "./MainLayout.js?vue&type=script&lang=js"
export * from "./MainLayout.js?vue&type=script&lang=js"

import "./MainLayout.scss?vue&type=style&index=0&id=0623b992&lang=scss&scoped=true"

import exportComponent from "C:\\Program Files\\Ampps\\www\\adapter\\metahumen\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0623b992"]])

export default __exports__